var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.00 28.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#00995D",
    strokeWidth: 0.00028,
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.05600000000000001
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6ZM12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10Z",
    fill: "#00995D",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23 10.1438C23 14.8819 20.359 22.3559 15.0771 26.6174C14.4449 27.1275 13.5551 27.1275 12.9229 26.6174C7.64096 22.3559 5 14.8819 5 10.1438C5 5.0938 9.02944 1 14 1C18.9706 1 23 5.0938 23 10.1438ZM21 10.1438C21 12.1757 20.4217 14.9456 19.1942 17.7283C18.0897 20.2321 16.5107 22.6301 14.4974 24.4574C14.2134 24.7152 13.7866 24.7152 13.5026 24.4574C11.4893 22.6301 9.91031 20.2321 8.80581 17.7283C7.57831 14.9456 7 12.1757 7 10.1438C7 6.21602 10.134 3.03195 14 3.03195C17.866 3.03195 21 6.21602 21 10.1438Z",
    fill: "#00995D",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.1b142fcd34101907f77ccaa9e58735f3.svg";
export { ForwardRef as ReactComponent };